<template>
  <div class="container">
    <div class="section-container">
      <div class="cards">
        <!-- Card 1: List Berita Gaya Pertama -->
        <div class="card">
          <div class="card-header">Berita Utama</div>
          <div class="card-body">
            
            <div v-for="news in newsList" :key="news.id" class="news-item">
              <div v-if="index === 0" class="news-full">
                <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" :alt="news.title" class="news-full-image"/>
                <h2>{{ news.judul }}</h2>
                <route-link :to="`/berita/${ news.id }`" class="news-link"
                  >Baca Selengkapnya</route-link
                >
              </div>
              <div v-else class="news-side">
                <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" :alt="news.title" class="news-thumbnail"/>
                <div class="news-content">
                  <h3>{{ news.judul }}</h3>
                  <p>{{ news.pubDate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 2: List Berita Gaya Kedua -->
        <div class="card">
          <div class="card-header">Khutbah Jum'at</div>
          <div class="card-body">
            <div v-for="news in khutbahList" :key="news.id" class="news-item">
              <div v-if="index === 0" class="news-full">
                <!-- <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" :alt="news.title" class="news-full-image"/> -->
                
                <router-link :to="`/berita/${news.id}`" class="news-link"
                  ><h2>{{ news.judul }}</h2></router-link
                >
              </div>
              <div v-else class="news-side">
                <!-- <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" :alt="news.title" class="news-thumbnail"/> -->
                <div class="news-content">
                  <h3>{{ news.judul }}</h3>
                  <p>{{ news.pubDate }}</p>
                  <router-link :to="`/berita/${news.id}`" class="news-link"
                  >Selengkapnya</router-link
                >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 3: List Video YouTube -->
        <div class="card">
          <div class="card-header">Video Terbaru</div>
          <div class="card-body">
            <div
              v-for="(video, index) in videos"
              :key="index"
              class="video-item"
            >
              <!-- <iframe
                :src="'https://www.youtube.com/embed/' + video.id"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="video-frame"
              ></iframe> -->
              <iframe
              :src="'https://www.youtube.com/embed/' + video.address"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="video-frame"
              ></iframe>
              
              <h4>{{ video.keterangan }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsList: [],
      khutbahList: [],
      videos: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/getNews/5");
        this.newsList = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    async fetchKhutbah() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/khutbahjumat/3");
        this.khutbahList = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    async fetchVideos() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/latestVideo");
        this.videos = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
    this.fetchKhutbah();
    this.fetchVideos();
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
}

.cards {
  display: flex;
  gap: 20px;
  width: 100%;
}

.card {
  flex: 1;
  max-width: 500px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.card-header {
  color: black;
  padding-left: 15px;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 5px solid #0a7a33;
}

.card-body {
  padding: 15px;
}

.news-item {
  margin-bottom: 15px;
}

.news-full {
  margin-bottom: 20px;
}

.news-full-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.news-link {
  display: inline-block;
  margin-top: 5px;
  color: #007bff;
  text-decoration: underline;
}

.news-side {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.news-thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
  border-radius: 4px;
}

.news-content h3 {
  margin: 0;
  font-size: 16px;
}

.news-content p {
  margin: 0;
  font-size: 12px;
  color: gray;
}

.news-item-alt {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.video-item {
  margin-bottom: 20px;
}

.video-frame {
  width: 100%;
  height: 180px;
  border: none;
  border-radius: 4px;
}
</style>
